module.exports = __webpack_public_path__ + "static/media/35.b1cf953c.jpg";